import React, { createContext, useState, useContext } from 'react'
import { gql, useQuery } from '@apollo/client'
import { set } from 'zod'
export const GET_SITE_ENABLED_LANGUAGES = gql`
  query GET_SITE_ENABLED_LANGUAGES {
    findFirstShopSetting {
      id
      enabled_languages {
        id
        language
        web_address_enabled
        web_address
        default_language
      }
    }
  }
`

interface LanguageContextValue {
  language: string
  setLanguage: (lang: string) => void
  allLanguages: string[]
  languageId: number
  webAddress: string
}

const allLanguages = ['en', 'lt']

const LanguageContext = createContext<LanguageContextValue>({
  language: 'en',
  setLanguage: () => {},
  allLanguages: [],
  languageId: 0,
  webAddress: '',
})

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState('en')
  const { data } = useQuery(GET_SITE_ENABLED_LANGUAGES)
  const [allLanguages, setLanguages] = useState<string[]>([])
  const [languageId, setLanguageId] = useState(0)
  const [webAddress, setWebAddress] = useState('')

  React.useEffect(() => {
    if (data?.findFirstShopSetting?.enabled_languages) {
      const defaultLang = data.findFirstShopSetting.enabled_languages.find(
        (l: any) => l.default_language === true
      )
      if (defaultLang) {
        setLanguage(defaultLang.language)
        setWebAddress(defaultLang.web_address)
      }
      setLanguages(
        data.findFirstShopSetting.enabled_languages.map((l: any) => l.language)
      )
    }
  }, [data])

  React.useEffect(() => {
    setLanguageId(allLanguages.indexOf(language))

    const webAddress = data?.findFirstShopSetting?.enabled_languages.find(
      (l: any) => l.language === language
    )?.web_address
    if (!webAddress) {
      // find default language
      const defaultLang = data?.findFirstShopSetting?.enabled_languages.find(
        (l: any) => l.default_language === true
      )
      console.log(
        'Default language:',
        defaultLang,
        data?.findFirstShopSetting?.enabled_languages
      )

      setWebAddress(defaultLang?.web_address)
    }
  }, [language, allLanguages])

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        allLanguages,
        languageId,
        webAddress,
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  return useContext(LanguageContext)
}
